import Vue from "vue";
import VueLocalStorage from "vue-localstorage";

import { service } from "@/api/api";

Vue.use(VueLocalStorage);

export default {
  state: {
    employeesList: null,
    //lista de reporte diario de los empleados
    dailyReportList: null,

    businessId: null || Vue.localStorage.get("businessID"),
    tregister:
      null || JSON.parse(JSON.stringify(Vue.localStorage.get("tregister"))),
    businessList: null,
    userBusinessList: null,
    newBusiness: {},

    tregisterList: null,
    currentSummaryEmployee: null || window.localStorage.getItem("currentSummaryEmployee"),
    currentTRegister: null,
    currentEmployee: null,
    systemUsers: null,
    summary: {
      year: null,
      monthly: {
        data: null,
        headers: null
      },
      month: null
    },
    resumenDashboard: null,
    dateCalc: null || JSON.parse(window.localStorage.getItem("dateCalc")),
    currentEmployeeContract: null,
    personalConcepts: [],
    employeesNumber: 0,
    currentBusiness: null,
    tregisterHistoricList: [],
    tregisterHistoricActual: null,
    vacationData: [],
    vacationVariables: null,
    ctsData: null,
    ctsHeaders: null
  },

  getters: {
    listEmploy(state) {
      if(!state.employeesList) return []
      return state.employeesList;
    },
    currentEmployee: state => id => {
      if(!state.employeesList) return null
      return state.employeesList.find(employee => employee.id === id);
    },
    tareoReportList(state) {
      if(!state.dailyReportList) return []
      return state.dailyReportList;
    },
    listBusiness(state) {
      return state.businessList;
    },
    listBusinessSelect: state => {
      if (!state.businessList) return [];
      return state.businessList.map(b => {
        return {
          name: b.name,
          id: b.id
        };
      });
    },
    actualBusiness(state){
      console.log(state.userBusinessList, state.businessId)
      return state.userBusinessList.find(business => business.id === state.businessId)
    },
    listPendingTRegister(state) {
      if (state.tregisterList)
        return state.tregisterList
      return [];
    },
    listDraftTRegister(state) {
      if (state.tregisterList)
        return state.tregisterList.filter(r => r.state == "draft")
      return [];
    },
    listDownTRegister(state) {
      if (state.tregisterList)
        return state.tregisterList.filter(r => r.state == "getdown")
      return [];
    },
    listHasEmployeeTRegister(state) {
      if (state.tregisterList)
        return state.tregisterList.filter(r => r.state == "hasemployee")
      return [];
    },
    listForEmployeeTRegister(state) {
      if (state.tregisterList)
        return state.tregisterList.filter(r => r.state == "foremployee")
      return [];
    },
    listRegisteredTRegister(state) {
      if (state.tregisterList)
        return state.tregisterList.filter(r => r.state == "registered");
      return [];
    },
    listCommission(state) {
      if (!state.currentEmployee) return [];
      return state.currentEmployee.variants
        ? state.currentEmployee.variants.sort((a, b) => {
            let d_a = new Date(a.date),
              d_b = new Date(b.date);
            return d_b - d_a;
          })
        : null;
    },
    listSystemUsers(state) {
      console.log(state.systemUsers);
      
      if (!state.systemUsers) return [];
      return state.systemUsers.filter(u => u.firstName).map(su => {
        return {
          ...su, roleIn: su.business && su.business.length > 0 ? su.business[0].roleIn : undefined
        }
      });
    },
    summaryByMonthlyHeaders(state) {
      if (!state.summary.monthly.headers) return [];
      let aux = state.summary.monthly.headers.filter(header => header.key !== "dayReport");
      return [...aux, {...state.summary.monthly.headers.find(header => header.key === "dayReport"), subheader: {
        absence:"Inasistencia",
        assistance: "Asistencia",
        excusedAbsence: "Inasistencia injustificada",
        extraHours25: "Horas ex. de 25%",
        extraHours35: "Horas ex. de 35%",
        medicalBreak: "Descanso médico",
        medicalBreakSubsidized: "Des. med. subsidiado",
        vacation: "Vacaciones",
      }}]
    },
    summaryByMonthData(state) {
      console.log("getter", state.summary);

      if (!state.summary.monthly.data) return [];
      return new Array(...state.summary.monthly.data);
    },
    summaryByYear(state) {
      if (!state.summary.year) return [];
      return state.summary.year.map(s => {
        return {
          firstName: s.firstName,
          firstSurname: s.firstSurname,
          id: s.id,
          grossSalary: s.grossSalary,
          jan: s.grossSalary,
          feb: s.grossSalary,
          mar: s.grossSalary,
          apr: s.grossSalary,
          may: s.grossSalary,
          jun: s.grossSalary,
          jul: s.grossSalary,
          ago: s.grossSalary,
          set: s.grossSalary,
          oct: s.grossSalary,
          nov: s.grossSalary,
          dec: s.grossSalary
        };
      });
    },
    calcAfp(state) {
      if (!state.summary.month) return null;
      return state.summary.month.pensionCalc;
    },
    calcRenta(state) {
      if (!state.summary.month) return null;
      return state.summary.month.resume5ta;
    },
    calcCts(state) {
      if (!state.summary.month) return null;
      return state.summary.month.resumeCts
    },
    calcGrati(state) {
      if (!state.summary.month) return null;
      return state.summary.month.gratificationProjection
    },
    calcActualGrati(state) {
      if (!state.summary.month) return null;
      return {
        gratification: state.summary.month.gratification,
        bonus: state.summary.month.extraGratifications
      }
    },
    calcDeductions(state){
      if(!state.summary.month) return null;
      return state.summary.month.deductionsArray
    },
    calcConcepts(state){
      if(!state.summary.month) return null;
      return state.summary.month.monthConcepts
    },
    vacationList(state){
      // if(state.vacationData.length === 0) return null;
      return state.vacationData
    },
    ctsInfo: state => {
      if(!state.ctsData) return [];
      return state.ctsData.map(row => {
        return {
          employee: row.employee,
          resumeCts: row.resumeCts, grossSalary: row.grossSalary, familyAssignment: row.familyAssignment
        }
      });
    },
    ctsTableHeaders: state => {
      if(!state.ctsHeaders) return [];
      return [...state.ctsHeaders, 
        {"label": "Asiganción familiar",
        "key": "familyAssignment",
        "type": "number"
      }]
    }
  },

  mutations: {
    ["SET_EMPLOYEESLIST"](state, payload) {
      state.employeesList = new Array(...payload);
    },
    ["SET_EMPLOYEESNUMBER"](state, payload) {
      state.employeesNumber = payload;
    },
    ["SET_DAILYREPORTLIST"](state, payload) {
      state.dailyReportList = new Array(...payload);
    },
    ["SET_TREGISTER"](state, payload) {
      state.tregister = Object.assign({}, state.tregister, payload);
      console.log(state.tregister)
      Vue.localStorage.set("tregister", JSON.stringify(state.tregister));
    },
    ["SET_BUSINESSLIST"](state, payload) {
      state.businessList = new Array(...payload);
    },
    ["SET_USERBUSINESSLIST"](state, payload) {
      state.userBusinessList = new Array(...payload);
    },
    ["SET_NEWBUSINESS"](state, payload) {
      state.newBusiness = JSON.parse(JSON.stringify(payload));
    },
    ["SET_CURRENT_SUMMARY_EMPLOYEE"](state, payload){
      state.currentSummaryEmployee = payload
    },
    //TRegistros
    ["SET_TREGISTERLIST"](state, payload) {
      state.tregisterList = new Array(...payload);
    },
    ["SET_CURRENTTREGISTER"](state, payload) {
      state.currentTRegister = payload;
    },
    ["SET_CURRENTEMPLOYEE"](state, payload) {
      state.currentEmployee = JSON.parse(JSON.stringify(payload));
    },

    ["SET_BUSINESSID"](state, payload) {
      state.businessId = payload;
      Vue.localStorage.set("businessID", payload);

    },
    ["SET_SYSTEMUSERS"](state, payload) {
      state.systemUsers = new Array(...payload);
    },
    ["SET_SUMMARY_MONTHLYDATA"](state, payload) {
      state.summary.monthly.data = new Array(...payload);
    },
    ["SET_SUMMARY_MONTHLYHEADERS"](state, payload) {
      state.summary.monthly.headers = new Array(...payload);
    },
    ["SET_SUMMARY_YEAR"](state, payload) {
      state.summary.year = new Array(...payload);
    },
    ["SET_SUMMARY_BY_MONTHDATA"](state, payload) {
      state.summary.month = JSON.parse(JSON.stringify(payload));
    },
    //dashboard
    ["SET_RESUME_DASHBOARD"](state, payload){
      state.resumenDashboard = JSON.parse(JSON.stringify(payload))
    },
    ["SET_DATE_CALC"](state, payload){
      window.localStorage.setItem("dateCalc", JSON.stringify(payload))
      state.dateCalc = payload
    },
    ["SET_CURRENT_EMPLOYEE_CONTRACT"](state, payload) {
      state.currentEmployeeContract = JSON.parse(JSON.stringify(payload))
    },
    ["SET_PERSONALCONCEPTS"](state, payload){
      state.personalConcepts = (JSON.parse(JSON.stringify(payload)))
    },
    ["SET_PERSONALCONCEPT_IDX"](state, payload){
      state.personalConcepts[payload.index] = payload.body
    },
    ["SET_CURRENT_BUSINESS"](state, payload) {
      state.currentBusiness = JSON.parse(JSON.stringify(payload))
    },
    ["SET_TREGISTER_HISTORIC_LIST"](state, payload) {
      state.tregisterHistoricList = Array.from(payload)
    },
    ["SET_TREGISTER_HISTORIC_ACTUAL"](state, payload) {
      state.tregisterHistoricActual = Object.assign({}, payload);
    },
    ["SET_VACATIONDATA"](state, payload) {
      state.vacationData = Array.from(payload);
    },
    ["SET_VACATIONVARIABLES"](state, payload) {
      state.vacationVariables = payload
    },
    ["SET_CTS_DATA"](state, payload){
      console.log(payload);
      state.ctsData = JSON.parse(JSON.stringify(payload))
    },
    ["SET_CTS_HEADERS"](state, payload){
      state.ctsHeaders = JSON.parse(JSON.stringify(payload))
    }
  },

  actions: {
    async getEmployees({ commit }, payload) {
      let res = await service.getEmployees(payload);
      if (res.status == 200){
        commit("SET_EMPLOYEESLIST", res.data.results);
        commit("SET_EMPLOYEESNUMBER", res.data.total);
      } 

      return res;
    },

    async getEmployeesDailyReport({ commit }, payload) {
      let res = await service.getEmployeesDailyReport(payload);
      console.log(res.data);
      
      if (res.status == 200) commit("SET_DAILYREPORTLIST", res.data);
      return res;
    },

    //report anual
    // async getEmployeeReport({}, payload) {
    //   let res = await service.getEmployeeReport(payload);
    //   return res;
    // },

    saveTRegister({ commit }, payload) {
      commit("SET_TREGISTER", payload);
    },
    async setTRegister({ state }, payload) {
      let res = await service.setTRegister({
        data: state.tregister,
        businessId: Vue.localStorage.get("businessID")
      });
      return res;
    },

    //obtiene concpetos de pago
    // async getItdConcepts(){
    //   let res = await service.getItdConcepts()
    //   return res
    // },

    //TRegisters <=========================================
    async createTRegister({ state }, payload) {
      let res = await service.createTRegister({
        data: payload,
        businessId: state.businessId
      });
      return res;
    },

    // async getTRegisters({ state, commit }, payload) {
    //   let r = await service.getTRegisters(payload);
    //   if (r.status == 200) commit("SET_TREGISTERLIST", r.data.results);
    //   return r;
    // },

    async getTRegisters({ state, commit }, payload){
      let r = await service.getTRegisters(payload)
      if(r.status == 200)
        commit("SET_TREGISTERLIST", r.data.results)
      return r
    },

    setCurrentTRegister({ commit }, payload) {
      commit("SET_CURRENTTREGISTER", payload);
    },

    async updateTRegister({ state }, payload) {
      let r = await service.updateTRegister({
        tregisterId: state.currentTRegister || payload.id,
        data: payload.body
      });

      return r;
    },

    async createEmployee({ state }, payload) {
      let r = await service.createEmployee({
        id: state.businessId,
        body: payload
      });
      return r;
    },

    async deleteTRegister({}, payload) {
      let r = await service.deleteTRegister(payload);
      return r;
    },

    async getTRegister({ state, commit }, payload=null) {
      let r
      if(payload){
        r = await service.getTRegister(payload);
        commit("SET_CURRENTTREGISTER", payload)
      }else{
        r = await service.getTRegister(state.currentTRegister);
      }
      return r;
    },
    //TRegisters-end =>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>

    async findByRuc({ commit }, payload) {
      let res = await service.getRUCdata(payload);
      if (res.status == 200) {
        commit("SET_NEWBUSINESS", res.data);
      }
      return res;
    },
    async getBusiness({ commit }, payload) {
      let res = await service.getBusiness(payload);
      if (res.status == 200) {
        commit("SET_BUSINESSLIST", res.data.results);
      }
      return res
    },
    async getBusinessById({ commit }, payload) {
      let res = await service.getBusinessById(payload);
      if (res.status == 200) {
        commit("SET_CURRENT_BUSINESS", res.data);
      }
      return res
    },
    async postBusiness({ commit }, payload) {
      let res = await service.postBusiness(payload);
      if (res.status == 200) {
        commit("SET_NEWBUSINESS", {});
      }
    },

    async putBusiness({}, payload) {
      let res = await service.putBusiness({
        id: Vue.localStorage.get("businessID"),
        body: payload
      });
      return res;
    },

    async putEnterprise({}, payload){
      let res = await service.putBusiness({
        id: payload.id,
        body: payload
      });
      return res;
    },

    async delBusiness({ commit }, payload) {
      let res = await service.deleteBusiness(payload);
      return res;
    },
    //obtener detalles de la empresa
    // async getDetailBusiness({},payload){
    //   console.log(state.businessId)
    //   let res = await service.getDetailBusiness(payload)
    //   return res
    // },

    //Comision
    async setCommission({ commit }, payload) {
      let res = await service.postCommissions(payload);

      return res;
    },
    async getCommissionList({ commit }, payload) {
      let res = await service.getCommissionList(payload);
      if (res.status == 200) {
        commit("SET_CURRENTEMPLOYEE", res.data);
      }
      return res;
    },
    async getDeductionList({  }, payload) {
      let res = await service.getDeductionList(payload);
      return res;
    },

    //elimina comision
    async deleteCommission({}, payload) {
      let res = await service.deleteCommission(payload);
      return res;
    },

    async getSystemUsers({ commit }) {
      let res = await service.getSystemUsers();
      if (res.status == 200) commit("SET_SYSTEMUSERS", res.data);
      console.log(res);
      return res;
    },
    async setSystemUsers({ commit }, payload) {
      let res = await service.postSystemUsers(payload);
      return res;
    },
    async linkSystemUsersBusiness({ commit }, payload) {
      let res = await service.linkSystemUsersBusiness(payload);
      return res;
    },
    async unlinkSystemUsersBusiness({ commit }, payload) {
      let res = await service.unlinkSystemUsersBusiness(payload);
      return res;
    },
    async updateSystemUserInfo({ commit }, payload) {
      let res = await service.updateSystemUsersInfo(payload);
      return res;
    },
    //summaries
    async summaryMonth({ commit }, payload) {
      let res = await service.getSummaryByMonth(payload);
      if (res.status == 200) {
        commit("SET_SUMMARY_MONTHLYDATA", res.data.data);
        commit("SET_SUMMARY_MONTHLYHEADERS", res.data.headers);
      }
      return res;
    },
    async summaryYear({ commit }, payload) {
      let res = await service.getSummaryByYear(payload);
      if (res.status == 200) {
        commit("SET_SUMMARY_YEAR", res.data.results);
      }
      return res;
    },
    async summaryByMonth({ commit }, payload) {
      let res = await service.getCalcByMonth(payload);
      if (res.status == 200) {
        console.log("respuesta 200", res.data.data);

        commit("SET_SUMMARY_BY_MONTHDATA", res.data.data);
      }
      return res;
    },

    //baja de tregistro
    async downTR({}, payload){
      let res = await service.downTR(payload)
      return res
    },

    async getDashboardInfo({commit}, payload){
      let res = await service.getDashboard(payload)
      if(res.status == 200){
        commit("SET_RESUME_DASHBOARD", res.data)
      }
      return res
    },

    async uploadContract({commit}, payload) {
      let res = await service.uploadContract(payload)
      if(res.status == 200){
        commit("SET_CURRENT_EMPLOYEE_CONTRACT", res.data)
      }
      return res
    },
    async massiveUpload({}, payload){
      let res = await service.cargaMasiva(payload)
      if(res.status == 200){

      }
      return res
    },
    async uploadRightHolders({}, payload){
      let res = await service.uploadRightHolders(payload)
      if(res.status == 200){

      }
      return res
    },
    async uploadHistoric({}, payload){
      let res = await service.uploadHistoric(payload)
      if(res.status == 200){

      }
      return res
    },
    /**
     * Conceptos personales para empleados
     */
    async listEmployeeConcepts({commit}, payload){
      let res = await service.getEmployeeConcepts(payload)
      if(res.status == 200){
        commit("SET_PERSONALCONCEPTS", res.data)
      }
      return res
    },
    async addEmployeeConcepts({commit}, payload){
      let res = await service.addEmployeeConcepts(payload)
      return res
    },
    async updateEmployeeConcepts({commit}, payload){
      let res = await service.updateEmployeeConcepts(payload)
      return res
    },
    async deleteEmployeeConcepts({commit}, payload){
      let res = await service.deleteEmployeeConcepts(payload)
      return res
    },
    async getEmployeeConceptsVar({commit}, payload){
      let res = await service.getVariablesConcepts(payload)
      return res
    },
    async getEmployeeConceptsHistoric({commit}, payload){
      let res = await service.getHistoricConcepts(payload)
      return res
    },
    async updateEmployeeData({commit}, payload) {
      let res = await service.updateEmployee(payload)
      return res
    },
    async clearEmployee({}, payload){
      let res = await service.clearEmployee(payload)
      return res;
    },
    async runEmployee({}, payload){
      let res = await service.runEmployee(payload);
      return res;
    },
    async validateMonth({}, payload){
      let res = await service.validateMonth(payload);
      return res;
    },
    async updateVariant({}, payload){
      let res = await service.updateVariant(payload);
      return res;
    },
    async downloadXls({}, payload){
      let res = await service.downloadXls(payload);
      return res
    },
    async downloadPdf({}, payload){
      let res = await service.downloadPdf(payload);
      return res
    },
    async updateCts({commit}, payload){
      let res = await service.updateCts(payload);
      return res;
    },
    async createTregisterHistoric({commit}, payload){
      let res = await service.createTregistroHistorico(payload);
      if(res.status === 200){
        commit("SET_TREGISTER", res.data)
      }
      return res;
    },
    async getTregistersHistoric({commit}, payload){
      let res = await service.getTregistroHistorico(payload);
      if(res.status === 200){
        commit("SET_TREGISTER_HISTORIC_LIST", res.data)
      }
      return res
    },
    async getTregistersHistoricDetail({commit}, payload){
      let res = await service.getTregistroHistoricoDetail(payload);
      if(res.status === 200){
        commit("SET_TREGISTER_HISTORIC_ACTUAL", res.data)
      }
      return res
    },
    async updateTregistersHistoric({commit}, payload){
      let res = await service.updateTregistroHistorico(payload);
      if(res.status === 200){
        commit("SET_TREGISTER", res.data)
      }
      return res
    },
    async deleteTregistersHistoric({commit}, payload){
      let res = await service.deleteTregistroHistorico(payload);
      if(res.status === 200){
        commit("SET_TREGISTER", null)
      }
      return res
    },
    async getVacationData({commit}, payload) {
      let res = await service.getVacations(payload);
      if(res.status === 200){
        commit("SET_VACATIONDATA", res.data.data)
      }
      return res
    },
    async setVacationVariables({commit}, payload){
      let res = await service.setVacationVariables(payload);
      if(res.status === 200){
        commit("SET_VACATIONVARIABLES", res.data)
      }
      return res
    },
    async downFixedConcepts({commit}, payload) {
      let res = await service.downEmployeeConcepts(payload);
      return res;
    },
    async getVacationVariables({commit}, payload) {
      console.log(payload)
      let res = await service.getVacationVariable(payload);
      console.log(res)
      if(res.status === 200 && !!res.data){
        commit("SET_VACATIONVARIABLES", res.data)
      }
      return res
    },
    async getDownData({commit}, payload) {
      let res = await service.getDownData(payload);
      return res;
    },
    async getCTSData({commit}, payload){
      let {status, data} = await service.getCtsData(payload);
      console.log(data);
      if(status === 200){
        commit("SET_CTS_DATA", data.data);
        commit("SET_CTS_HEADERS", data.headers);
      }
      return status
    },
    async getEmployeeCts(context, payload){
      let res = await service.getEmployeeCts(payload);
      return res
    },
    async getEmployeeCtsReal(context, payload){
      let res = await service.getEmployeeCtsReal(payload);
      return res
    },
    async setEmployeeCtsReal(context, payload){
      let res = await service.setEmployeeCtsReal(payload);
      return res
    },
    async getEmployeeGratiReal(context, payload){
      let res = await service.getEmployeeGratiReal(payload);
      return res
    },
    async setEmployeeGratiReal(context, payload){
      let res = await service.setEmployeeGratiReal(payload);
      return res
    },
    async recalculate(context, payload){
      let res = await service.recalculate(payload);
      return res
    },
    async createVacationHistoric(context, payload){
      let res = await service.createVacationHistoric(payload);
      return res;
    },
    async listVacationHistoric(context, payload){
      let res = await service.getVacationHistoric(payload);
      return res;
    },
    async updateVacationHistoric(context, payload){
      let res = await service.updateVacationHistoric(payload);
      return res;
    },
    async createBusinessHistoric(context, payload){
      let res = await service.createBusinessHistoric(payload);
      return res;
    },
    async getBusinessHistory(context, payload){
      let res = await service.getBusinessHistory(payload);
      return res;
    },
    async getBusinessHistoricDetail(context, payload){
      let res = await service.getBusinessHistoricDetail(payload);
      return res;
    },
    async updateBusinessHistoric(context, payload){
      let res = await service.updateBusinessHistoric(payload);
      return res;
    },
    async deleteBusinessHistoric(context, payload){
      let res = await service.deleteBusinessHistoric(payload);
      return res;
    },
    async getBusinessPlame({}, payload){
      console.log("en plame ", payload);
      let res = await service.getBusinessPlame(payload)
      return res
    },
    async getInteresCTS({},payload){
      let res = await service.getFactors(payload);
      return res;
    }
  }
};
